import { render, staticRenderFns } from "./DISelect.vue?vue&type=template&id=6daeab5a&"
import script from "./DISelect.vue?vue&type=script&lang=js&"
export * from "./DISelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports